import React, { useEffect, useRef } from 'react';
import styles from './Demographics.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { type AppDispatch } from '../../../reducers/store';
import InfoSelectors from '../../../selectors/InfoSelectors';
import {
    Button,
    ButtonVariants,
    LoadingOverlay,
    Modal,
} from '@tcc-online/common-components';
import DemographicSelector from '../../selectors/DemographicSelector';
import SortingCriteria from '@tcc-online/sorting-criteria';
import DemographicActions from '../../actions/DemographicActions';
import { useTranslate } from 'react-translate.ts';
import { TRANSLATIONS_ROOT_KEY } from '../../../constants/translation.constants';

export default function Demographics() {
    const dispatch = useDispatch<AppDispatch>();
    const info = InfoSelectors.useGetInfo();
    const { data, loading, isOpen } = useSelector(
        DemographicSelector.getDemographics,
    );
    const translate = useTranslate();
    const submitRef = useRef<() => any>();

    useEffect(() => {
        if (isOpen && info.data?.showDemographicCriteria) {
            dispatch(DemographicActions.getDemographics());
        }
    }, [isOpen, info.data?.showDemographicCriteria]);

    return (
        <Modal
            classNames={{ modal: styles.modal, card: styles.card }}
            isVisible={isOpen && info.data?.showDemographicCriteria}
            onClose={close}
        >
            {loading ? (
                <LoadingOverlay />
            ) : (
                <>
                    <p>
                        {translate(
                            TRANSLATIONS_ROOT_KEY +
                                '.participant.demographic-criteria.p1',
                        )}
                    </p>
                    <SortingCriteria
                        criteria={data}
                        submit={(callback) => (submitRef.current = callback)}
                        requiredMessage={translate('fe.error.required')}
                    />

                    <div className={styles.buttons}>
                        <Button
                            variant={ButtonVariants.negative}
                            onClick={cancel}
                        >
                            {translate(
                                TRANSLATIONS_ROOT_KEY +
                                    '.participant.button.dont-answer',
                            )}
                        </Button>
                        <Button
                            variant={ButtonVariants.positive}
                            onClick={submit}
                        >
                            {translate(
                                TRANSLATIONS_ROOT_KEY +
                                    '.participant.button.answer',
                            )}
                        </Button>
                    </div>
                </>
            )}
        </Modal>
    );

    function close() {
        dispatch(DemographicActions.toggleDemographics(false));
    }

    function cancel() {
        dispatch(DemographicActions.postAnswer([]));
    }

    function submit() {
        const values = submitRef.current?.();
        if (values) {
            const entries = Object.entries(values);
            if (entries.length > 0) {
                dispatch(
                    DemographicActions.postAnswer(
                        entries.map((entry: [string, { value: number }]) => {
                            const [key, value] = entry;

                            return {
                                id: parseInt(key, 10),
                                value: value.value,
                            };
                        }),
                    ),
                );
            }
        }
    }
}
